import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideo2Off: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVideo2Off"><Path d="M18.7812 21.375L17.2188 22.625L1.21875 2.625L2.78125 1.375L18.7812 21.375Z" fill="currentColor"/><Path d="M12.7988 19.5H2V6.00098L12.7988 19.5Z" fill="currentColor"/><Path d="M22.5 18.1182L18.5 16.1182V7.88184L22.5 5.88184V18.1182Z" fill="currentColor"/><Path d="M17 16.748L7.20117 4.5H17V16.748Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideo2Off;
